import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // urlChang:"http://192.168.1.179/demo_vue/public/home/demo/upload",
    // ckeditorsUrl:"http://115.29.150.19:3030/admin/Common/editorUpload",
    // urlChang: "http://115.29.150.19:3030/admin/Common/upload",
    // ckeditorsUrl:"http://www.b2cadmin.com/admin/Common/editorUpload",
    // urlChang: "http://www.b2cadmin.com/admin/Common/upload",


     // emailEditorUpload:"//admin-api.uniquecncmach.com/admin/Common/emailEditorUpload/",
     // ckeditorsUrl:"//admin-api.uniquecncmach.com/admin/Common/editorUpload/",
     // urlChang: "//admin-api.uniquecncmach.com/admin/Common/upload/",
     // urlApp:"//admin-api.uniquecncmach.com/admin/Common/mobileAppFile",
     // urlExper:"//admin-api.uniquecncmach.com",
     // urlImport:"//admin-api.uniquecncmach.com/detect/AExternalLink/import",


    // ckeditorsUrl:"http://admin-api.oemserviceses.com/admin/Common/editorUpload/",
    // urlChang: "http://admin-api.oemserviceses.com/admin/Common/upload/",
    // urlApp:"http://admin-api.oemserviceses.com/admin/Common/mobileAppFile",
    // urlExper:"http://admin-api.oemserviceses.com/",
    // urlImport:"http://admin-api.oemserviceses.com/detect/AExternalLink/import",


    // ckeditorsUrl:"//admin-api.us.uniquecncmach.com/admin/Common/editorUpload/",
    // urlChang: "//admin-api.us.uniquecncmach.com/admin/Common/upload/",
    // urlApp:"//admin-api.us.uniquecncmach.com/admin/Common/mobileAppFile",
    // urlExper:"//admin-api.us.uniquecncmach.com",
    // urlImport:"//admin-api.us.uniquecncmach.com/detect/AExternalLink/import",

    //
 // emailEditorUpload:"//manage-admin.chukouplus.com/admin/Common/emailEditorUpload/",
 // ckeditorsUrl:"//manage-admin.chukouplus.com/admin/Common/editorUpload/",
 // urlChang: "//manage-admin.chukouplus.com/admin/Common/upload/",
 // urlApp:"//manage-admin.chukouplus.com/admin/Common/mobileAppFile",
 // urlExper:"//manage-admin.chukouplus.com/",
 // urlImport:"//manage-admin.chukouplus.com/detect/AExternalLink/import",


   emailEditorUpload:"//manage-admin.show.chukouplus.com/admin/Common/emailEditorUpload/",
   ckeditorsUrl:"//manage-admin.show.chukouplus.com/admin/Common/editorUpload/",
   urlChang: "//manage-admin.show.chukouplus.com/admin/Common/upload/",
   urlApp:"//manage-admin.show.chukouplus.com/admin/Common/mobileAppFile",
   urlExper:"//manage-admin.show.chukouplus.com/",
   urlImport:"//manage-admin.show.chukouplus.com/detect/AExternalLink/import",




    // urlExper:"http://xb.admin.com/detect/AExternalLink/import",
    // ckeditorsUrl:"http://www.reanodb2c.com/admin/Common/editorUpload/",
    // urlChang: "http://www.reanodb2c.com/admin/Common/upload/",
    // urlApp:"http://www.reanodb2c.com/admin/Common/mobileAppFile",

      // emailEditorUpload:"//xb.admin.com/admin/Common/emailEditorUpload/",
      // ckeditorsUrl:"http://xb.admin.com/admin/Common/editorUpload/",
      // urlChang: "http://xb.admin.com/admin/Common/upload/",
      // urlApp:"http://xb.admin.com/admin/Common/mobileAppFile",
      // urlExper:"http://xb.admin.com",
      // urlImport:"http://xb.admin.com/detect/AExternalLink/import",


      // emailEditorUpload:process.env.VUE_APP_EMAIL_EDITOR_UPLOAD,
      // ckeditorsUrl:process.env.VUE_APP_CKEDITORS_URL,
      // urlChang: process.env.VUE_APP_URL_CHANGE,
      // urlApp:process.env.VUE_APP_URL_APP,
      // urlExper:process.env.VUE_APP_URL_EXPER,
      // urlImport:process.env.VUE_APP_URL_IMPORT,
      urlRequest:process.env.VUE_APP_URL,

    headers:window.sessionStorage.getItem('signature'),
    count: 0,
    adminleftnavnum:"/",
    menu:[],
    reAddRoutes:true,
    company:""
  },
  mutations: {
    increment (state) {
      state.count++
    }

  },
  actions: {
  },
  modules: {
  }
})
